import useAnalyticsEventTracker from "hooks/useAnalyticsEventTracker";
import "./styles.scss"
import { ReactComponent as User } from 'assets/icons/header/user.svg'
import { Link } from "react-router-dom";




const LogBtn = ({ text }) => {

    return (
        <div className="log-btn-container">
            <Link to={"https://dashboard-ping-proxies.goodface.com.ua/"} className="log-btn" onClick={useAnalyticsEventTracker({ category: "Navigation", action: "Login Click" })}>
                <User />
                {text}
            </Link>
        </div>
    )
}






export default LogBtn;